import Teste from './components/Teste';
import './App.css';

function App() {
  return (
    <div className="App">
      <Teste/>
    </div>
  );
}

export default App;
